import React from 'react';

const ImageSizeTestBanner = () => (
  <div className="alert alert-warning fade show" role="alert">
    <div className="font-weight-bold">
      Image Size Warning
    </div>
    <div>
      Some of your images are below the recommended minimum size 1000x1000 pixels. We recommend using larger images to improve the display on site.
    </div>
  </div>
);

export default ImageSizeTestBanner;
